import React, { useEffect, useState } from 'react';
import surveyUtils from '../../utils/survey';
import GoogleFormModal from './formsSurveyModal';

function isSurveyActive(survey) {
  if (!survey || survey.status !== 'ACTIVA') return false;
  const now = new Date();
  const from = survey.dateFrom ? new Date(survey.dateFrom) : null;
  const to = survey.dateTo ? new Date(survey.dateTo) : null;
  if (from && now < from) return false;
  if (to && now > to) return false;
  return true;
}

function toEmbeddedGoogleFormUrl(url) {
  try {
    const u = new URL(url);
    u.searchParams.set('embedded', 'true');
    return u.toString();
  } catch {
    return url;
  }
}

const SurveyLoader = (props) => {
  const [activeSurvey, setActiveSurvey] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    async function fetchActiveSurveys() {
      try {
        const res = await surveyUtils.getActiveSurveys({ userId: props.user ? props.user._id : null });
        if (res && res.data && Array.isArray(res.data)) {
          const found = res.data.find(isSurveyActive);
          if (found) {
            setActiveSurvey(found);
            setShow(true); // Show modal automatically if found
          }
        }
      } catch (err) {
        setActiveSurvey(null);
      }
    }
    fetchActiveSurveys();
  }, [props.user]);

  if (!activeSurvey || !activeSurvey.url) {
    return null; // No active survey to show
  }

  const embeddedFormUrl = toEmbeddedGoogleFormUrl(activeSurvey.url);

  return (
    <GoogleFormModal
      show={show}
      setShow={setShow}
      id="active-survey-modal"
      formUrl={embeddedFormUrl}
      height={700}
      survey={activeSurvey}
      user={props.user}
    />
  );
};

export default SurveyLoader;